import React from 'react';
import { motion } from 'framer-motion';
import { Shield, TrendingUp, Users, Zap } from 'lucide-react';

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.1 } },
};

const item = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: 'easeOut' } },
};

export const About = () => {
  const benefits = [
    {
      icon: Zap,
      title: 'Otomatis & Efisien',
      description: 'Sistem otomatis mengurangi pekerjaan manual hingga 80%, hemat waktu dan tenaga pengurus.'
    },
    {
      icon: Shield,
      title: 'Aman & Terpercaya',
      description: 'Data terenkripsi dengan standar keamanan internasional, backup otomatis setiap hari.'
    },
    {
      icon: TrendingUp,
      title: 'Laporan Real-Time',
      description: 'Pantau keuangan dan status pembayaran kapan saja, dimana saja dengan dashboard interaktif.'
    },
    {
      icon: Users,
      title: 'Mudah Digunakan',
      description: 'Interface intuitif yang mudah dipahami warga dan pengurus tanpa training khusus.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-foreground mb-6">
            Tentang <span className="text-brand-700">Sistem IPL</span>
          </h2>
          <p className="text-lg text-foreground/70">
            Sistem IPL adalah solusi digital modern yang dirancang khusus untuk mempermudah pengelolaan
            Iuran Pemeliharaan Lingkungan di kompleks perumahan dan apartemen. Dengan teknologi cloud
            terkini, kami membantu ribuan kompleks di seluruh Indonesia mengelola keuangan mereka
            dengan lebih transparan dan efisien.
          </p>
        </motion.div>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
        >
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <motion.div
                key={index}
                variants={item}
                whileHover={{ y: -4 }}
                className="group p-6 rounded-2xl bg-gradient-to-br from-brand-50 to-background border border-border hover:border-brand-300 hover:shadow-xl transition-all duration-300"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-brand-100 to-gold-400/20 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="text-brand-700" size={28} />
                </div>
                <h3 className="text-xl font-bold text-foreground mb-3">{benefit.title}</h3>
                <p className="text-foreground/70 leading-relaxed">{benefit.description}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
